'use client'

import { Provider } from 'react-redux'
import { store } from '../store/store' // Adjust the path as needed

// Applies withCredentials + the shared 401 handler to every axios call.
// Imported for its side effects, so it must load before any page fires a request.
import '../lib/axiosConfig'
import '../styles/macos-tokens.scss'
import '../styles/polish.scss'
import '../styles/register.scss'
import { TenantProvider } from '@/context/TenantContext'
import { ConfirmProvider } from '@/components/shared/ConfirmDialog'

export function Providers({ children }) {
  return (
    <Provider store={store}>
      <TenantProvider>
        <ConfirmProvider>
          {children}
        </ConfirmProvider>
      </TenantProvider>
    </Provider>
  )
}
